import { UseDataQuery } from '../../../../hooks/useDataQuery/dataQuery.types';

export const getOrderTotalsQueryKey = (
  searchParams: Record<string, any>,
): UseDataQuery['queryKey'] => ['/orders-list/totals', undefined, searchParams];
